// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2017, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.FocusedCBGSliceSegment--segment--STc5T {
  stroke: black;
  stroke-width: 2;
  pointer-events: none;
  fill: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/trends/cbg/FocusedCBGSliceSegment.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAMF;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2017, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n:export {\n  stroke: 2;\n}\n\n.segment {\n  stroke: black;\n  stroke-width: 2;\n  pointer-events: none;\n  fill: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stroke": `2`,
	"segment": `FocusedCBGSliceSegment--segment--STc5T`
};
export default ___CSS_LOADER_EXPORT___;
